export enum RecommendationType {
  EXTENSION = 'EXTENSION',
  EXISTING = 'EXISTING',
  ALL = 'ALL',
  SORTING = 'SORTING'
  }
